<template>
  <v-layout pa-0 ma-0 column>
    <v-container fluid class="text-xs-left title font-weight-bold">
      <v-layout>
        <v-flex xs12 align-end flexbox>
          {{this.isCanada ? $t('webTransfer.termsConditionsCA') : $t('webTransfer.termsConditions')}}
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-text class="pt-0 pb-1">
      <span v-html="getLocalizedTermsAndConditionsText"></span>
    </v-card-text>
    <br/>
    <v-divider/>
    <v-card-actions>
      <v-container pa-1>
        <v-layout justify-center >
          <v-btn flat round class="tstAcceptTermsCheck gtm-upload-accept-terms" data-ffid="accept-terms-check" data-tstid="AcceptTermsCheck" @click="accepted=!accepted">
            <img v-if="accepted" src="../assets/art/Checkmark-checked.svg" class="pr-2 gtm-upload-accept-terms">
            <img v-if="!accepted" src="../assets/art/Checkmark-unchecked.svg" class="pr-2 gtm-upload-accept-terms"/>
            <span class='text-none body-1 gtm-upload-accept-terms' >{{$t('webTransfer.iAcceptTC')}}</span>
          </v-btn>
        </v-layout>
        <v-container xs12 pa-1/>
        <v-layout justify-center>
          <v-btn :disabled="!accepted" class="upload tstAcceptTermsButton" data-ffid="accept-terms-btn" data-tstid="AcceptTermsButton" @click="$emit('termsAccepted')" round color="primary">{{$t('webTransfer.iAccept')}}</v-btn>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-layout>
</template>

<script>

export default {
  name: 'TermsItem',
  data: () => ({
    accepted: false,
    isCanada: false
  }),
  computed: {
    getLocalizedTermsAndConditionsText: function () {
      let tcText = this.isCanada ? this.$i18n.t('webTransfer.tcDescriptionCA') : this.$i18n.t('webTransfer.tcDescription')
      tcText = tcText.replace(/\[\[termsLink\]\]/gi, `<a href="#" class="tstTermsAndConditionsInlineLink" data-ffid="terms-inline-link" data-tstid="TermsAndConditionsInlineLink" onclick="document.getElementById('termsLink').click();">${this.isCanada ? this.$i18n.t('webTransfer.termsConditionsCA') : this.$i18n.t('webTransfer.termsConditions')}</a>`)
      tcText = tcText.replace(/\[\[privacyPolicyLink\]\]/gi, `<a href="#" class="tstPrivacyPolicyInlineLink" data-ffid="privacy-inline-link" data-tstid="PrivacyPolicyInlineLink" onclick="document.getElementById('privacyPolicyLink').click();">${this.$i18n.t('webTransfer.privacyPolicy')}</a>`)
      tcText = tcText.replace(/\[\[acceptableUsePolicyLink\]\]/gi, `<a href="#" class="tstAcceptableUsePolicyInlineLink" data-tstid="AcceptableUsePolicyInlineLink" onclick="document.getElementById('acceptableUsePolicyLink').click();">${this.$i18n.t('webTransfer.acceptableUsePolicy')}</a>`)
      return tcText
    }
  },
  mounted () {
    this.accepted = false
    this.isCanada = window.location.hostname.includes('.ca')
  },
  methods: {
  }
}
</script>
